import { REDUCER } from '../reducers/reducersConst';
import { CONTENT_SYNCHRONIZATION_STATUS, CDN_SYNCHRONIZATION_STATUS } from '../const';

let defaultContentState = {
  contentBooks: {},
  contentSynchronizationStatus: CONTENT_SYNCHRONIZATION_STATUS.EMPTY,
  cdnSynchronizationStatus: CDN_SYNCHRONIZATION_STATUS.EMPTY,
  contentSynchronizationDate: {},
  activitiesContent: {}
};

export let content = (state = defaultContentState, action) => {
  switch (action.type) {
    case REDUCER.CONTENT.SET_CONTENT_BOOK:
      return {
        ...state,
        contentBooks: {
          ...state.contentBooks,
          [action.contentBook.id]: action.contentBook
        }
      };
    case REDUCER.CONTENT.SET_CDN_SYNCRHONIZATION:
      return {
        ...state,
        cdnSynchronizationStatus: action.cdnSynchronizationStatus
      };
    case REDUCER.CONTENT.SET_CONTENT_SYNCHRONIZATION:
      return {
        ...state,
        contentSynchronizationStatus: action.contentSynchronizationStatus
      };
    case REDUCER.CONTENT.SET_CONTENT_SYNCHRONIZATION_DATE:
      return {
        ...state,
        contentSynchronizationDate: action.contentSynchronizationDate
      };
    case REDUCER.CONTENT.SET_ACTIVITY_CONTENT:
      return {
        ...state,
        activitiesContent: {
          ...state.activitiesContent,
          [action.activityContent.activityContentId]: action.activityContent
        }
      };
    default:
      return state;
  }
};
